"use client";

import { formatDualPrice } from "@/utils/functions/formatDualPrice";
import type { DualPriceDisplayProps } from "./types";

export default function DualPriceDisplay({
  usdAmount,
  displayCurrencyCode,
  convertedAmount,
  acceptedCurrencyCodes,
  dualPricingEnabled = false,
  locale,
  className = "",
  multiCurrencyConfig,
}: DualPriceDisplayProps) {
  const resolvedAcceptedCurrencyCodes =
    multiCurrencyConfig?.acceptedCurrencyCodes ?? acceptedCurrencyCodes;
  const resolvedDualPricingEnabled =
    multiCurrencyConfig?.dualPricingEnabled ?? dualPricingEnabled;

  const formattedPrice = formatDualPrice({
    usdAmount,
    displayCurrencyCode,
    convertedAmount,
    acceptedCurrencyCodes: resolvedAcceptedCurrencyCodes,
    dualPricingEnabled: resolvedDualPricingEnabled,
    locale,
  });

  const priceText =
    formattedPrice.mode === "dual" && formattedPrice.secondary
      ? `${formattedPrice.primary} / ${formattedPrice.secondary}`
      : formattedPrice.primary;

  return (
    <span className={className || undefined} translate="no">
      {priceText}
    </span>
  );
}
